/**
 * Reads regional selection services and related loading/error flags from CommunicationStore.
 */

import { useMemo } from "react";

import { messageIds } from "../constants";

export default function useRegionalSelectionServices({ CommunicationStore }) {
  const servicesMessage =
    CommunicationStore?.getMessagesToID?.({ to: messageIds.services })?.message ||
    [];
  const services = useMemo(
    () =>
      Array.isArray(servicesMessage)
        ? servicesMessage.filter(
            (service) => service?.ShowInFaktenblatt === true
          )
        : [],
    [servicesMessage]
  );

  const loadingServices =
    CommunicationStore?.getMessagesToID?.({ to: messageIds.servicesLoading })
      ?.message || false;

  const servicesError =
    CommunicationStore?.getMessagesToID?.({ to: messageIds.servicesError })
      ?.message || null;

  return { services, loadingServices, servicesError };
}
